import React from "react";

const PostContent = ({ content }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-lg mt-6">
      <div
        className="prose max-w-none text-gray-800"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default PostContent;
